/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
// import { ActionButton, Text } from "@adobe/react-spectrum";
import {
  TextField,
  Text,
  Button,
  ActionButton,
  Link,
  Grid,
  View,
} from "@adobe/react-spectrum";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import {
  JsonFormsDispatch,
  useJsonForms,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";

import DeleteOutline from "@spectrum-icons/workflow/DeleteOutline";
import _ from "lodash";
import { useSelector } from "react-redux";
// import Attach from "@spectrum-icons/workflow/Attach";
import React, { useRef, useState, useEffect, useContext } from "react";
import { FormContext } from "../context/FormsContext";
import {
  substituteMessageVariables,
  evaluateContextRule,
  extractPath,
} from "../utils/commonUtils";
import styles from "./css/FileUploader.module.scss";

export const FileUploaderRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("FileUploader")
);

/**
 * Custom renderer for a AdvancedCombobox .
 */
function FileUploaderRenderer({
  uischema,
  schema,
  visible,
  enabled,
}: RendererProps) {
  const fileInputRef: any = useRef();

  const [touched, setTouched] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);

  const [fileUploadError, setFileUploadError] = useState<any>(null);
  const [fileCoreError, setFileCoreError] = useState<any>(null);
  const uiSchemaOptions = uischema?.options;
  const requiredError =
    uiSchemaOptions?.errors?.required || "This field is required.";
  const uploaderConfig: any = uiSchemaOptions?.uploaderConfig;
  const formDataKey: any = uiSchemaOptions?.formDataKey || null;
  const { required: isRequired = [] } = schema || {};
  const required = isRequired.includes(formDataKey) || false;
  // Disabled when there are errors
  const [__, setContext] = useContext<any>(FormContext);
  const descriptionErrorText = "This field is required.";
  const {
    filesLimit = 1,
    buttonLabel = "Upload",
    acceptedExtensions,
    multiple = false,
    showUploadInfo = false,
    uploadOnSubmit = false,
    maxFileNameLength,
    maxFileSizeInBytes,
    validator,
    detailedView = false,
    deleteConfig: {
      showDeleteBtn = true,
      isDeleteABtn = true,
      btnLabel = "Delete",
      labelStyle = {},
      deleteBtnStyle = {
        verticalAlign: "middle",
        cursor: "pointer",
        border: "none",
      },
      deleteSpectrumProps = {},
      deleteButtonContent = "",
    } = {},
    validateDescription = false,
    listingStyle = {},
    detailedListStyle = {},
    label,
    infoText,
    infoLabelStyle = {},
    NO_FILES_SELECTED_ERROR = "No files selected",
    maxDescriptionLength = 500,
    buttonStyle = { maxWidth: "84px" },
    showCustomBtn = true,
    buttonClass = "",
    buttonId = "exampleFile",
    followCustomValidation = false,
    showFilePickerOnLoad = false,
    showModalShortDescriptionText = false,
    modalShortDescriptionPreSelect = "Please attach files.",
    modalShortDescriptionPostSelect = "Please add a short description for each file.",
    modalShortDescriptionPreSelectButtonText = "Select files",
    modalShortDescriptionPostSelectButtonText = "Add more files",
    detailedViewConfig: {
      showDelete = true,
      isDeleteABtn: detailedIsDeleteABtn = true,
      btnLabel: detailedBtnLbl = "Delete",
      deleteBtnStyle: detailedDeleteBtnStyle = {
        cursor: "pointer",
      },
      deleteSpectrumProps: detailedDeleteSpectrumProps = {},
      deleteButtonContent: detailedDeleteButtonContent = "",
      showDescription = true,
    } = {},
  } = uploaderConfig || {};

  const [fileLimit, setFileLimit] = useState(false);
  const { renderers, cells, config: jsonFormConfig } = useJsonForms();
  const jsonFormContext = useJsonForms();

  const onSuccessCallbacks = jsonFormConfig?.lifecycleHooks?.onSuccessCallbacks;
  /** callbacks  */
  /*  callback function allows to update uploaded file/files */
  const fileUploadCallBack = onSuccessCallbacks?.fileUploadCallBack;
  const fileContextHandler = onSuccessCallbacks?.fileContextHandler;
  /*  callback function allows to set/unset description errors in multifile upload */
  const fileUploadErrorHandler = onSuccessCallbacks?.fileUploadErrorHandler;
  const externalHandlers = jsonFormConfig?.lifecycleHooks?.externalHandlers;

  const customValidator = externalHandlers?.uploadValidator || null;
  const data = jsonFormContext?.core?.data || {};

  const { config: { formTouched = false } = {} } = jsonFormContext || {};

  const hasTouched = formTouched || touched;

  const hasErrors = () => {
    const err = false;
    setFileCoreError(null);
    if (hasTouched && required && uploadedFiles.length === 0) {
      setFileCoreError(requiredError);
    }
    return err;
  };

  /** method to set files to context in case of modal file uploader  */

  const setFilesToContext = (filesToSet: any, contextFormKey: any) => {
    setContext((oldValues: any) => ({
      ...oldValues,
      data: { ...data, ...{ [contextFormKey]: filesToSet } },
    }));
  };

  useEffect(() => {
    hasErrors();
  }, [jsonFormContext?.core?.errors, hasTouched, uploadedFiles]);

  useEffect(() => {
    if (fileUploadErrorHandler) {
      /** This  callback function allows to set/unset description errors in multifile upload */
      fileUploadErrorHandler(setDescriptionError);
    }
    if (fileContextHandler) {
      /** This  callback function allows to set/unset uploaded file details to context in case of modal file uploader */
      fileContextHandler({ setFilesToContext });
    }
    if (data && data[formDataKey]) {
      setUploadedFiles(data[formDataKey]);
      if (filesLimit && data[formDataKey].length === filesLimit)
        setFileLimit(true);
    } else {
      setUploadedFiles([]);
      setFileLimit(false);
    }

    // Check configuration for showing file picker on load
    if (showFilePickerOnLoad) {
      fileInputRef.current.click();
    }
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--btnContent",
      `"${buttonLabel}"`
    );
  }, [buttonLabel]);
  useEffect(() => {
    /** callback to set uploaded file details to the  page component on every uploadFiles changes
     * @input uploadedFiles  : uploaded file information
     * @input uploadOnSubmit: value from uploaderConfig,  indicates whether
     *                        file upload on form submit or with out submit button click
     *                       This can be set as true in modal file uploader for action on modal submit
     * @formDataKey :This can be used to set files accordingly if we are using multiple file uploaders in a page
     */

    if (fileUploadCallBack) {
      fileUploadCallBack(uploadedFiles, uploadOnSubmit, formDataKey);
    }
  }, [uploadedFiles]);

  const inputProps: any = {
    type: "file",
  };
  if (acceptedExtensions) {
    inputProps.accept = acceptedExtensions;
  }
  if (multiple) {
    inputProps.multiple = multiple;
  }

  const isMIMEType = (fileType: string) =>
    fileType === "audio/*" ||
    fileType === "video/*" ||
    fileType === "image/*" ||
    fileType === "text/*" ||
    /\w+\/[-+.\w]+/g.test(fileType);

  const fileValidator = (file: any, uploaded: any) => {
    let valid = true;
    validator.forEach((item: any) => {
      switch (item.code) {
        case "FILE_SIZE_EXCEEDED":
          if (file.size > maxFileSizeInBytes) {
            valid = false;
            setFileUploadError(
              substituteMessageVariables(file, item.message, uploaderConfig)
            );
          }
          break;

        case "NOT_MIME_TYPE":
          if (!isMIMEType(file.type)) {
            valid = false;
            setFileUploadError(
              substituteMessageVariables(file, item.message, uploaderConfig)
            );
          }
          break;

        case "EMPTY_FILE":
          if (file.size === 0) {
            valid = false;
            setFileUploadError(
              substituteMessageVariables(file, item.messag, uploaderConfig)
            );
          }
          break;
        case "MAX_CHAR_FILE_NAME":
          if (file.name.length > maxFileNameLength) {
            valid = false;
            setFileUploadError(
              substituteMessageVariables(file, item.message, uploaderConfig)
            );
          }
          break;
        case "DUPLICATE_FILE_NAME":
          if (uploaded.findIndex((f: any) => f.name === file.name) !== -1) {
            valid = false;
            setFileUploadError(
              substituteMessageVariables(file, item.message, uploaderConfig)
            );
          }
          break;
        case "INCORRECT_EXTENSION":
          {
            const fileExt = `.${file.name.split(".").pop()}`;
            if (
              acceptedExtensions &&
              !acceptedExtensions
                .split(",")
                .map((extn: string) => extn.toLowerCase().trim())
                .includes(fileExt.toLowerCase().trim())
            ) {
              valid = false;
              setFileUploadError(
                substituteMessageVariables(file, item.message, uploaderConfig)
              );
            }
          }
          break;
        case "MAX_UPLOAD_LIMIT":
          if (filesLimit && uploaded.length === filesLimit) {
            valid = false;
            setFileUploadError(
              substituteMessageVariables(file, item.message, uploaderConfig)
            );
          }
          break;

        default:
          break;
      }
    });
    return valid;
  };

  const updateContext = (uploaded: any) => {
    if (formDataKey && !multiple) {
      const nameString =
        uploaded.length > 0
          ? uploaded.map((file: { name: any }) => file.name).join(",")
          : null;
      setContext((oldValues: any) => ({
        ...oldValues,
        data: { ...data, ...{ [formDataKey]: nameString } },
      }));
    }
  };

  const prepareUpload = (files: any) => {
    /* If file limit reached or if its not multiple creating new array instead of pushing new file to uploaded files
     */
    const uploaded =
      uploadedFiles.length === filesLimit || !multiple
        ? []
        : [...uploadedFiles];
    let error = 0;
    setIsFilePicked(true);
    files.forEach((file: any): any => {
      let isFileValid = false;

      if (customValidator && followCustomValidation) {
        const { isValid, errorMsg } = customValidator(file, uploaded);
        isFileValid = isValid;
        if (!isValid && errorMsg) {
          setFileUploadError(errorMsg);
        }
      } else {
        isFileValid = validator ? fileValidator(file, uploaded) : true;
      }
      const fileObj = file;
      if (isFileValid) {
        fileObj.required = validateDescription && showDescription;
        if (validateDescription && showDescription) {
          fileObj.isValid = false;
        }
        uploaded.push(fileObj);
        if (filesLimit && uploaded.length === filesLimit) setFileLimit(true);
      } else {
        error += 1;
      }
    });

    if (error === 0) {
      setUploadedFiles(uploaded);
      updateContext(uploaded);
    } else {
      fileInputRef.current.value = null;
      setFileLimit(false);
    }
  };

  const resetMeta = () => {
    setFileUploadError(null);
    setFileLimit(false);
    setIsFilePicked(false);
  };

  const changeFileHandler = (event: {
    target: { files: any; setCustomValidity: any };
  }) => {
    setTouched(true);
    resetMeta();
    if (uploadedFiles.length === filesLimit || !multiple) {
      setUploadedFiles([]);
      updateContext([]);
    }
    const sliceFileArray = Function.prototype.call.bind(Array.prototype.slice);
    const selectedFiles = sliceFileArray(event.target.files);
    if (selectedFiles.length === 0) {
      setFileUploadError(NO_FILES_SELECTED_ERROR);
    } else {
      prepareUpload(selectedFiles);
    }
  };

  const setDescription = (val: any, index: any) => {
    const uploaded = [...uploadedFiles];
    uploaded[index].fileDescription = val;
    if (validateDescription) {
      uploaded[index].isValid = !!(val && val.trim().length > 0);
    }
    setUploadedFiles(uploaded);
  };

  const deleteFile = (file: any) => {
    const uploaded = [...uploadedFiles];
    uploaded.splice(uploaded.indexOf(file), 1);
    setUploadedFiles(uploaded);
    updateContext(uploaded);
    if (uploaded.length === 0 || uploaded.length < filesLimit) {
      fileInputRef.current.value = null;
      setFileLimit(false);
      if (uploaded.length === 0) {
        resetMeta();
      }
    }
  };

  const getUploadedFilesList = () => (
    <>
      {uploadedFiles.map(
        (
          file: {
            name:
              | boolean
              | React.ReactChild
              | React.ReactFragment
              | React.ReactPortal
              | null
              | undefined;
          },
          index: number
        ) => (
          <div
            key={`simple_file_${index}`}
            className={styles.inlineBlockliContainer}
            style={{ ...listingStyle }}
          >
            <span className={styles.inlineBlockli}>{file.name}</span>
            {showDeleteBtn && (
              <span className={styles.action}>
                {isDeleteABtn ? (
                  <Button
                    data-testid="custom-file-delete-btn"
                    UNSAFE_style={{ ...deleteBtnStyle }}
                    {...deleteSpectrumProps}
                    aria-label="Delete"
                    onPress={() => deleteFile(file)}
                  >
                    {deleteButtonContent ? (
                      <JsonFormsDispatch
                        renderers={renderers}
                        cells={cells}
                        uischema={deleteButtonContent}
                        schema={{}}
                      />
                    ) : (
                      <DeleteOutline />
                    )}
                  </Button>
                ) : (
                  <Link
                    UNSAFE_style={{ ...deleteBtnStyle }}
                    {...deleteSpectrumProps}
                    aria-label="Delete"
                    onPress={() => deleteFile(file)}
                  >
                    {btnLabel}
                  </Link>
                )}
              </span>
            )}
          </div>
        )
      )}
    </>
  );

  const getCharactersRemaining = (value: any) => {
    const remaining = maxDescriptionLength - value.length;
    return remaining;
  };

  // Determine if the component should be visible and enabled
  let componentVisibility = visible;
  let componentEnabled = enabled;

  // If there is a context rule, evaluate it and use that visibility/enabled rule instead.
  if (uischema.options?.contextRule) {
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    const reduxState = useSelector((state: any) =>
      _.get(state?.reduxState, scope)
    );
    const contextRuleValidation = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    );
    componentVisibility = contextRuleValidation?.visible;
    componentEnabled = contextRuleValidation?.enabled;
  }

  return (
    <div hidden={!componentVisibility} data-testid="custom-file-uploader">
      {label && (
        <div className={styles.label} style={{ ...labelStyle }}>
          <span> {label}</span>
        </div>
      )}
      <input
        onChange={changeFileHandler}
        className={`inputFileCtrl ${buttonClass} ${
          showCustomBtn ? styles.customFileInput : ""
        }  `}
        data-testid="inputFileCtrl"
        style={{ ...buttonStyle }}
        {...inputProps}
        disabled={!componentEnabled || (fileLimit && multiple)}
        ref={fileInputRef}
        id={`${buttonId}`}
        required={required}
      />

      {showModalShortDescriptionText && uploadedFiles.length > 0 && (
        <div className={styles.modalShortDescription}>
          <span>{modalShortDescriptionPostSelect}</span>{" "}
          {filesLimit && uploadedFiles.length !== filesLimit && (
            <Link onPress={() => fileInputRef.current.click()}>
              {modalShortDescriptionPostSelectButtonText}
            </Link>
          )}
        </div>
      )}

      {showModalShortDescriptionText && uploadedFiles.length === 0 && (
        <div className={styles.modalShortDescription}>
          <span>{modalShortDescriptionPreSelect}</span>{" "}
          <Link onPress={() => fileInputRef.current.click()}>
            {modalShortDescriptionPreSelectButtonText}
          </Link>
        </div>
      )}

      {showUploadInfo &&
        uploadedFiles.length > 0 &&
        !fileUploadError &&
        !detailedView && (
          <Text
            aria-label="fileNames"
            UNSAFE_className="file_details"
            data-testid="file_details"
          >
            {getUploadedFilesList()}
          </Text>
        )}
      {infoText && (
        <div style={{ ...infoLabelStyle }} className={styles.infoLabel}>
          <span> {infoText}</span>
        </div>
      )}

      {((isFilePicked && fileUploadError) || fileCoreError) && (
        <div className={styles.errorMessage}>
          {fileUploadError || fileCoreError}
        </div>
      )}

      {showUploadInfo && uploadedFiles.length > 0 && detailedView && (
        <div style={{ ...detailedListStyle }} className={styles.fileListing}>
          {uploadedFiles &&
            uploadedFiles.map((file: any, index: any) => (
              <Grid
                key={`multi_file_${index}`}
                areas={["header  action", "description description"]}
                columns={["3fr", "1fr"]}
                rows={["auto", "auto"]}
                alignItems="center"
                UNSAFE_className={styles.fileItem}
              >
                <View gridArea="header">
                  <Text>
                    <strong>{file.name}</strong>
                  </Text>
                </View>
                <View gridArea="action" UNSAFE_style={{ justifySelf: "end" }}>
                  {showDelete && (
                    <div className={styles.action}>
                      {detailedIsDeleteABtn ? (
                        <ActionButton
                          UNSAFE_style={{ ...detailedDeleteBtnStyle }}
                          {...detailedDeleteSpectrumProps}
                          aria-label="Delete"
                          onPress={() => deleteFile(file)}
                        >
                          {detailedDeleteButtonContent ? (
                            <JsonFormsDispatch
                              renderers={renderers}
                              cells={cells}
                              uischema={detailedDeleteButtonContent}
                              schema={{}}
                            />
                          ) : (
                            <DeleteOutline />
                          )}
                        </ActionButton>
                      ) : (
                        <Link
                          UNSAFE_style={{ ...detailedDeleteBtnStyle }}
                          {...detailedDeleteSpectrumProps}
                          aria-label="Delete"
                          onPress={() => deleteFile(file)}
                        >
                          {detailedBtnLbl}
                        </Link>
                      )}
                    </div>
                  )}
                </View>
                <View gridArea="description">
                  {showDescription && (
                    <div className={styles.description}>
                      <div className={styles.descriptionLabel}>
                        {getCharactersRemaining(file.fileDescription || "")}
                      </div>
                      <TextField
                        label="Description"
                        value={file.fileDescription || ""}
                        onChange={(val: any) => setDescription(val, index)}
                        maxLength={maxDescriptionLength}
                        {...(validateDescription && {
                          validationState: file.isValid ? "valid" : "invalid",
                        })}
                        isRequired={validateDescription}
                        width="100%"
                      />
                      {descriptionError && !file.fileDescription && (
                        <div className={styles.errorInline}>
                          {descriptionErrorText}
                        </div>
                      )}
                    </div>
                  )}
                </View>
              </Grid>
            ))}
        </div>
      )}
    </div>
  );
}
export default withJsonFormsLayoutProps(FileUploaderRenderer);
